class ResultPagination {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="ResultPagination"]'),
      ...options
    };
  }

  static addSeparator(current, page, offset) {
    const separator = `...`;
    return Math.abs(page - current) > offset ? separator : null;
  }

  static generatePaginationArray(pages, current) {
    const maxNumberOfElements = 5;
    const firstPage = 1;
    const lastPage = pages;
    const offset = Math.ceil(maxNumberOfElements / 2);
    const offsetLeft = [...Array(offset).keys()]
      .map(
        value =>
          Math.abs(value - current) <= firstPage || Math.abs(value - current) === current
            ? null
            : Math.abs(value - current)
      )
      .reverse();
    const offsetRight = [...Array(offset).keys()].map(
      value => (current + value >= lastPage || current + value === current ? null : current + value)
    );

    const array = [
      firstPage,
      ResultPagination.addSeparator(current, firstPage, offset),
      ...offsetLeft,
      current !== firstPage && current !== lastPage ? current : null,
      ...offsetRight,
      ResultPagination.addSeparator(current, lastPage, offset),
      lastPage
    ];

    return array.filter(item => item !== null).map(item => ({
      value: item,
      isSelected: item === current
    }));
  }

  static paginationArray(data) {
    const { total, perPage, current = 1 } = data;
    const pages = Math.ceil(total / perPage);

    if (Number.isNaN(total)) throw new Error('Total param should be number');
    if (Number.isNaN(perPage)) throw new Error('perPage param should be number');

    const array = ResultPagination.generatePaginationArray(pages, current);

    return array;
  }

  static generateElements(array, prevText, nextText) {
    const urlParams = new URLSearchParams(window.location.search);
    const currentPage = urlParams.get('page') ? Number(urlParams.get('page')) : 1;

    const items = array.map(item => {
      const newUrlParams = urlParams;
      newUrlParams.set('page', item.value);
      const url = `?${newUrlParams.toString()}`;
      const isActive = item.value === currentPage;
      if (Number.isInteger(item.value)) {
        return `<li class="${isActive ? 'active' : ''}"><a href="${url}">${item.value}</a></li>`;
      }
      return `<li class="p-dots"><a>${item.value}</a></li>`;
    });

    const firstItem = array[0].value;
    const lastItem = array[array.length - 1].value;

    if (firstItem !== currentPage) {
      const newUrlParams = urlParams;
      newUrlParams.set('page', currentPage - 1);
      const url = `?${newUrlParams.toString()}`;
      items.unshift(`<li class="prev"><a href="${url}">${prevText}</a></li>`);
    }

    if (lastItem !== currentPage) {
      const newUrlParams = urlParams;
      newUrlParams.set('page', currentPage + 1);
      const url = `?${newUrlParams.toString()}`;
      items.push(`<li class="next"><a href="${url}">${nextText}</a></li>`);
    }

    const list = `<ul class="pagination">${items.join('')}</ul>`;

    return list;
  }

  render(name, data) {
    const { moduleList } = this.config;

    if (!moduleList) {
      return;
    }

    moduleList.forEach(element_ => {
      const element = element_;
      const elementPlaceholder = element;
      const { resultName } = element.dataset;
      if (resultName && resultName === name) {
        let { prevText, nextText } = element.dataset;

        prevText = prevText || 'Prev';
        nextText = nextText || 'Next';

        const pagingData = {
          total: data.totalPages,
          perPage: 1,
          current: data.currentPage
        };

        if (pagingData.total > 1) {
          const array = ResultPagination.paginationArray(pagingData);
          const paginationItems = ResultPagination.generateElements(array, prevText, nextText);
          elementPlaceholder.innerHTML = paginationItems;
        } else {
          element.style.display = 'none';
        }
      }
    });
  }
}

export default ResultPagination;
